import { IAddEditEventState, ICalendarSettingsState, IRecurrenceSettingsState, ISearchToolbarState, ISelectEventsFromOtherCalendarsState, IState } from "../classes/state";
import { IText, IText_Days, IText_EventViews, IText_MainToolbar, IText_SearchToolbar, IText_SelectEvents } from "../classes/text";

import { IOption } from "../classes/option";
import { IText_AddEditEvent, IText_AddEditEvent_FieldNames, IText_AddEditEvent_General, IText_AddEditEvent_Validation } from "../classes/text_AddEditEvent";

/* tslint:disable:object-literal-sort-keys */

export const viewModeOptions: IOption[] = [
  { text: "Daily", value: "DAILY" },
  { text: "Daily List", value: "DAILYLIST" },
  { text: "Weekly", value: "WEEKLY" },
  { text: "Monthly", value: "MONTHLY" },
  { text: "Event List", value: "MONTHLYLIST" },
];

export const initialCalendarSettings: ICalendarSettingsState = {
  action: "",
  calendarId: 0,
  currentDate: null,
  displayedEventId: 0,
  displayedEventLocalEndDate: null,
  displayedEventLocalStartDate: null,
  eventScreenMode: "LIST",
  iCalStartDate: new Date(),
  selectedDateColor: "",
  firstDayOfWeek: "",
  headerAndBorderColor: "",
  hasCreatePermission: false,
  hasDeletePermission: false,
  hasEditPermission: false,
  isTwoWayCalendar: false,
  localFromDate: new Date(),
  localToDate: new Date(),
  portletInstanceId: 0,
  selectedDate: new Date(),
  todaysDate: new Date(),
  todayColor: "",
  userDateFormat: "",
  viewMode: "",
  viewModeOptions,

  portalId: 0, // 87516
  pageId: 0, // 2294677,
  objectId: 0, // 2294679, // This isn't needed, is on event objects, remove this property.
  contextId: 0, // 2294678,
  parentId: 0, // 2294679,
  pageName: "",
  calendarName: "",
  useModernAddAndEditEventScreen: false,
};

export const initialSearchToolbarState: ISearchToolbarState = {
  searchCategoryOptions: [],
  searchFilterOptions: [],
  searchText: "",
  selectedSearchCategoryValue: "",
  selectedSearchFilterValue: "",
};

const defaultDaysText: IText_Days = {
  monday: "",
  tuesday: "",
  wednesday: "",
  thursday: "",
  friday: "",
  saturday: "",
  sunday: "",
};

const defaultEventViewsText: IText_EventViews = {
  allDay: "",
  areYouSureYouWantToDeleteThisEvent: "",
  areYouSureYouWantToRemoveThisEvent: "",
  atLeastOneDayMustBeSelected: "",
  attachments: "",
  backToCalendar: "",
  cancel: "",
  category: "",
  contact: "",
  daily: "",
  dateAndTime: "",
  delete: "",
  deleteAllOccurrences: "",
  deleteEvent: "",
  description: "",
  doYouWantToDeleteAllOccurrencesOfTheRecurringEvent: "",
  downloadAll: "",
  editEvent: "",
  endRecurrence: "",
  event: "",
  exportEvent: "",
  loading: "",
  loadingEvents: "",
  location: "",
  members: "",
  monthly: "",
  noEventsInThisTimePeriod: "",
  noEventsOnThisDay: "",
  nonMembers: "",
  on: "",
  onlyDeleteThisEvent: "",
  originatingSource: "",
  orJustThisOne: "",
  participants: "",
  price: "",
  publishedCalendars: "",
  recurrence: "",
  region: "",
  register: "",
  registration: "",
  registrationDeadline: "",
  remove: "",
  removeEvent: "",
  repeats: "",
  repeatsEvery: "",
  repeatsOn: "",
  save: "",
  server: "",
  thisIsARecurringEvent: "",
  to: "",
  unregister: "",
  weekly: "",
  weeks: "",
  yearly: "",
  yourEventWillBePermanentlyDeleted: "",
  yourEventWillBePermanentlyRemoved: "",
};

const defaultMainToolbarText: IText_MainToolbar = {
  nextDay: "",
  previousDay: "",
  nextWeek: "",
  previousWeek: "",
  nextMonth: "",
  previousMonth: "",
  nextFourMonths: "",
  previousFourMonths: "",
  nextYear: "",
  previousYear: "",
  currentlyShowing: "",

  daily: "",
  dailyList: "",
  weekly: "",
  monthly: "",
  monthlyList: "",

  today: "",

  newEvent: "",
  importEvents: "",

  icalRSSFeed: "",
  subscribeEmail: "",
  exportEvents: "",
  copyLink: "",
  theLinkIsNowCopied: "",
  print: "",
  viewOtherCalendars: "",

  useArrowKeysToNavigateThroughOptions: "",
};

const defaultSearchToolbarText: IText_SearchToolbar = {
  clearSearchButton: "",
  defaultCategoryOption: "",
  defaultCategoryPrompt: "",
  defaultFilterPrompt: "",
  defaultFilterOption: "",
  searchButton: "",
  searchText_placeholder: "",
};

const defaultSelectEventsText: IText_SelectEvents = {
  calendarSingular: "",
  calendarPlural: "",
  clearAllSelectedCalendars: "",
  close: "",
  loading: "",
  no: "",
  pager_currentlyDisplayingPage: "",
  pager_displayPage: "",
  pager_displayPreviousPageOfResults: "",
  pager_displayPreviousSetOfPageLinks: "",
  pager_displayNextPageOfResults: "",
  pager_displayNextSetOfPageLinks: "",
  pager_noNextPageOfResults: "",
  pager_noNextSetOfPageLinks: "",
  pager_noPreviousPageOfResults: "",
  pager_noPreviousSetOfPageLinks: "",
  pager_of: "",
  pager_ofResults: "",
  selectEventsFromOtherCalendars: "",
  thisServerHasNoCalendars: "",
  viewSelectedCalendars: "",
  youHaveSelected: "",
};

export const initialInternationalizedText: IText = {
  days: defaultDaysText,
  eventViews: defaultEventViewsText,
  mainToolbar: defaultMainToolbarText,
  monthNamesAbbreviated: [],
  monthNamesComplete: [],
  searchToolbar: defaultSearchToolbarText,
  selectEvents: defaultSelectEventsText,
};

export const initialSelectEventsFromOtherCalendarsSettings: ISelectEventsFromOtherCalendarsState = {
  childServerIds: [],
  currentServerId: 0,
  openSelectEventsFromOtherCalendarsModal: false,
  parentServerId: 0,
  rootServerId: 0,
  servers: [],
  checkedNodeItemIds: [],
  checkedNodeCalendarIds: [],
  expandedNodeItemIds: [],
  hasServerData: false,
  pager_currentPageNumber: 1,
};

export const initialRecurrenceSettings: IRecurrenceSettingsState = {
  openRecurrencePatternModal: false,
  updatedRecurrenceDescription: "",
  updatedRecurrencePattern: null,
};

// CalendarSettings for AddEditEvent:
const defaultAddEditEvent_FieldNamesText: IText_AddEditEvent_FieldNames = {
  allDay: "",
  endDate: "",
  location: "",
  recurrence: "",
  startDate: "",
  subject: "",
};

const defaultAddEditEvent_GeneralText: IText_AddEditEvent_General = {
  addRecurrence: "",
  after: "",
  cancel: "",
  create: "",
  date: "",
  deleteRecurrence: "",
  editEvent: "",
  editRecurrence: "",
  endRecurrence: "",
  eventId: "",
  loading: "",
  never: "",
  newEvent: "",
  occurences: "",
  on: "",
  recurrence: "",
  update: "",
  updateAllRecurringEvents: "",
  updateThisEventOnly: "",
};

const defaultAddEditEvent_ValidationText: IText_AddEditEvent_Validation = {
  dateThatRecurrenceEndsOnIsRequired: "",
  dateThatRecurrenceEndsOnMustBeEqualToOrAfterStartDate: "",
  eventEndTimeMustBeSameOrLaterThanStartTime: "",
  fixStartDateBeforeSettingRecurrence: "",
  locationMaximumXCharacters: "",
  subjectIsRequired: "",
  subjectMaximumXCharacters: "",
};

export const initialInternationalizedText_AddEditEvent: IText_AddEditEvent = {
  fieldNames: defaultAddEditEvent_FieldNamesText,
  general: defaultAddEditEvent_GeneralText,
  validation: defaultAddEditEvent_ValidationText,
};

export const initialCalendarSettings_AddEditEvent: IAddEditEventState = {
  addEditText: initialInternationalizedText_AddEditEvent,
  currentDateOnServer: null,
  currentStartDate: null,
  dateOfFirstEventInRecurrence: null,
  errorMessage: "",
};

// Complete State:
const initialState: IState = {
  // Search Toolbar state:
  calendarSettings: initialCalendarSettings,
  addOrEditEvent: initialCalendarSettings_AddEditEvent,
  currentEvent: null,
  events: [],
  numAjaxCallsInProgress: 0,
  searchToolbar: initialSearchToolbarState,
  text: initialInternationalizedText,
  width: 0,
  selectEventsFromOtherCalendarsSettings: initialSelectEventsFromOtherCalendarsSettings,
  recurrenceSettings: initialRecurrenceSettings,
};

export default initialState;
